import { c as _c } from "react/compiler-runtime";
import { CircularProgress, Switch, Tooltip } from "@flat-ui";
import { Box } from "@mui-wrapper";
/** Diameter of the loading indicator, and the width of the slot kept free for it */
const LOADING_INDICATOR_SIZE = "14px";
/**
 * Switch following the FARO Design System, with an optional tooltip and loading indicator.
 *
 * Wraps the flat-ui switch instead of restyling MUI's, so that the design system stays the
 * single source of truth for how a switch looks. The tooltip and the loading indicator are not
 * part of the flat-ui component, which is the only reason this wrapper still exists.
 */
export function FaroSwitch(props) {
  const $ = _c(20);
  let isLoading;
  let onChange;
  let switchProps;
  let tooltipTextChecked;
  let tooltipTextNotChecked;
  if ($[0] !== props) {
    ({
      isLoading,
      tooltipTextNotChecked,
      tooltipTextChecked,
      onChange,
      ...switchProps
    } = props);
    $[0] = props;
    $[1] = isLoading;
    $[2] = onChange;
    $[3] = switchProps;
    $[4] = tooltipTextChecked;
    $[5] = tooltipTextNotChecked;
  } else {
    isLoading = $[1];
    onChange = $[2];
    switchProps = $[3];
    tooltipTextChecked = $[4];
    tooltipTextNotChecked = $[5];
  }
  const tooltipText = props.checked ? tooltipTextChecked : tooltipTextNotChecked;
  const shouldShowTooltip = !props.disabled && !!tooltipText;
  const t0 = shouldShowTooltip ? tooltipText : "";
  let t1;
  if ($[6] !== onChange || $[7] !== props.checked) {
    t1 = event => onChange?.(event, !props.checked);
    $[6] = onChange;
    $[7] = props.checked;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== switchProps || $[10] !== t1) {
    t2 = <Switch {...switchProps} onToggle={t1} />;
    $[9] = switchProps;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t0 || $[13] !== t2) {
    t3 = <Tooltip component="div" title={t0}>{t2}</Tooltip>;
    $[12] = t0;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== isLoading) {
    t4 = isLoading !== undefined && <Box sx={{
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
      width: LOADING_INDICATOR_SIZE,
      ml: 0.5
    }}>{isLoading && <CircularProgress size={LOADING_INDICATOR_SIZE} />}</Box>;
    $[15] = isLoading;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t3 || $[18] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}